/**
 * Country name mapping utility
 * Maps ISO 2-letter country codes to full country names
 */

export const COUNTRY_CODE_TO_NAME: Record<string, string> = {
  RS: "Serbia",
  ME: "Montenegro",
  MK: "North Macedonia",
  BA: "Bosnia and Herzegovina",
  HR: "Croatia",
  SI: "Slovenia",
  AL: "Albania",
  BG: "Bulgaria",
  RO: "Romania",
  GR: "Greece",
  HU: "Hungary",
  SK: "Slovakia",
  CZ: "Czech Republic",
  PL: "Poland",
  DE: "Germany",
  FR: "France",
  IT: "Italy",
  ES: "Spain",
  GB: "United Kingdom",
  NL: "Netherlands",
  BE: "Belgium",
  AT: "Austria",
  CH: "Switzerland",
  SE: "Sweden",
  NO: "Norway",
  DK: "Denmark",
  FI: "Finland",
  US: "United States",
  CA: "Canada",
  AU: "Australia",
  NZ: "New Zealand",
  BR: "Brazil",
  RU: "Russia",
  TR: "Turkey",
  UA: "Ukraine",
  CN: "China",
  IN: "India",
  JP: "Japan",
  KR: "South Korea",
  IL: "Israel",
  AE: "UAE",
  SA: "Saudi Arabia",
  EG: "Egypt",
  ZA: "South Africa",
  XK: "Kosovo",
  KS: "Kosovo",
};

/**
 * Get full country name from ISO 2-letter country code
 * @param countryCode - ISO 2-letter country code (e.g., "RS", "MK")
 * @returns Full country name (e.g., "Serbia", "North Macedonia") or the code if not found
 */
export const getCountryName = (countryCode: string | undefined | null): string => {
  if (!countryCode) return "";
  const code = countryCode.toUpperCase().trim();
  return COUNTRY_CODE_TO_NAME[code] || code;
};

/**
 * Get ISO 2-letter country code from full country name
 * @param countryName - Full country name (e.g., "Serbia", "North Macedonia")
 * @returns ISO 2-letter country code (e.g., "RS", "MK") or the name if not found
 */
export const getCountryCode = (countryName: string | undefined | null): string => {
  if (!countryName) return "";
  const name = countryName.trim();
  const entries = Object.entries(COUNTRY_CODE_TO_NAME);
  const found = entries.find(([_, value]) => value.toLowerCase() === name.toLowerCase());
  return found ? found[0] : name;
};

